import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserDragDropDemo from 'src/games/demos/phaserDragDropDemo/Main';

interface DragDropDemoProps extends PageProps<{}> {
}

class DragDropDemo extends React.Component<DragDropDemoProps> {
    constructor(props: DragDropDemoProps) {
        super(props);
        bindAllOfThis(this, DragDropDemo.prototype);
    }

    render() {
        return <div>
            <PhaserDragDropDemo />
        </div>;
    }
}

export default DragDropDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/DragDropDemo.tsx